import { isValidDate } from '@tyler-components-web/core';
export var ISO_8601_REGEX = /^([\+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-2])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T\s]((([01]\d|2[0-3])((:?)[0-5]\d)?|24\:?00)([\.,]\d+(?!:))?)?(\17[0-5]\d([\.,]\d+)?)?([zZ]|([\+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/;
export var ISO_TIMEZONE_REGEX = /a-z/i;
var FUTURE_YEAR_COERCION = 10; // The number of years in the future to coerce two-digit years into current century
/**
 * Parses a date string value to a `Date` object in local time.
 * @param str The date string value.
 */
export function parseDateString(value) {
    value = value.replace(/_|\s/g, ''); // Remove potential extraneous characters
    // We first check if this is a valid date in ISO 8601 format and return it if so
    if (ISO_8601_REGEX.test(value)) {
        var iso8601Date = new Date(value);
        // This is an ISO string, but does it have a timezone? If not, we add current timezone offset
        if (!ISO_TIMEZONE_REGEX.test(value)) {
            iso8601Date.setMinutes(iso8601Date.getMinutes() + iso8601Date.getTimezoneOffset());
        }
        if (isValidDate(iso8601Date)) {
            return iso8601Date;
        }
    }
    var values = [];
    // We accept dates with a "/" or "-" separator and in the format of MM/DD/YYYY
    if (value.indexOf('/') !== -1) {
        values = value.split('/');
    }
    else if (value.indexOf('-') !== -1) {
        values = value.split('-');
    }
    else if ((value.length === 6 || value.length === 8) && !isNaN(+value)) {
        values = [value.substring(0, 2), value.substring(2, 4), value.substring(4)];
    }
    var hasMonthDayYear = values.length === 3;
    // tslint:disable-next-line: prefer-const
    var month = values[0], day = values[1], year = values[2];
    // Ensure are month and year values are coerced from 0 to 1 in case of incomplete entry
    if (month === '0') {
        month = '1';
    }
    if (day === '0') {
        day = '1';
    }
    // Trap for the case where only 3 digit years are entered
    if (typeof year === 'string' && year.length === 3) {
        year = year.padEnd(4, '0');
    }
    if (hasMonthDayYear) {
        var isValidMonthLength = month.length === 1 || month.length === 2;
        var isValidDayLength = day.length === 1 || day.length === 2;
        var isValidYearLength = year.length === 2 || year.length === 4;
        if (!isValidMonthLength || !isValidDayLength || !isValidYearLength) {
            return null;
        }
    }
    else {
        return null;
    }
    // Check if we need to coerce two-digit years to the four-digit equivalent
    if (year.length === 2) {
        var minYear = new Date().getFullYear() - (100 - FUTURE_YEAR_COERCION);
        var maxYear = new Date().getFullYear() + FUTURE_YEAR_COERCION;
        var minYearCentury = String(minYear).slice(0, 2);
        var maxYearCentury = String(maxYear).slice(0, 2);
        var normalizedMaxYear = +String(maxYear).slice(2);
        year = +year <= normalizedMaxYear ? "" + maxYearCentury + year : "" + minYearCentury + year;
    }
    var numMonth = +month;
    var numDay = +day;
    var numYear = +year;
    if (numMonth > 12) {
        numMonth = 12;
    }
    var maxDaysInMonth = new Date(numYear, numMonth, 0).getDate();
    if (numDay > maxDaysInMonth) {
        numDay = maxDaysInMonth;
    }
    var parsedDate = new Date(numYear, numMonth - 1, numDay, 0, 0, 0, 0);
    return isValidDate(parsedDate) ? parsedDate : null;
}
/**
 * Formats a `Date` to a specified format.
 * @param str The date string value.
 */
export function formatDate(date) {
    var month = String(date.getMonth() + 1).padStart(2, '0');
    var day = String(date.getDate()).padStart(2, '0');
    var year = date.getFullYear();
    return [month, day, year].join('/');
}
